const CMS_BASE_URL = 'https://api.dev.auxo.dk'

// In-memory fallback / initial cache with the exact seeded CMS entries
export const FALLBACK_DATA = {
  pages: [
    {
      id: "8a4d241d-fba3-4cad-8e3a-f3c4b843c3ab",
      slug: "hifi",
      title: "HiFi",
      seo_title: "HiFi & JARC Audio | High-End Lydoplevelser & Højttalere - JARCon",
      meta_description: "Udforsk JARC Audio universet. Passion for DIY HiFi, håndbyggede højttalere, rørforstærkere og pladespillere. Kom forbi til en uforpligtende lytteoplevelse i Sydals.",
      original_url: "https://www.jarcon.dk/hifi",
      hero_heading: "HiFi",
      hero_subheading: "HiFi og DIY HiFi har været en passion og hobby for mig i mange år.",
      hero_image: [
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-10d0de04f8d84061b64ec76601f0ef3c-mv2.jpg"
      ],
      content: "<p>HiFi og DIY HiFi har været en passion og hobby for mig i mange år.</p><p>Jeg har lavet pladespillere, kabler og tilbehør, men primært højtalerbyg, har min interesse</p><p>Det er blevet til mange spændende højtaler konstruktioner gennem årene.</p><p>Målet er at skabe en højtaler, som kan gengive al slags musik med nerve og nærvær, hvor lytteren glemmer at man lytter til HiFi, men føler sig omslugt at musikken.</p><p>Du er velkommen til at komme forbi og lytte til mit setup med DIY højtalere, pladespiller og rørforstærker</p>",
      gallery_slug: "hifi-setup",
      cta_text: "Kom forbi til et lyt og en kop kaffe",
      cta_link: "/kontakt",
      terms: { category: ["hifi"] }
    },
    {
      id: "65afe3bb-b778-44b1-b863-86b6fedbeaa5",
      slug: "forside",
      title: "Forside",
      seo_title: "JARCon ApS | JARC Audio – High-End HiFi & Højttalerbyg i Sydals",
      meta_description: "Oplev musik med nerve hos JARCon ApS. Specialister i high-end HiFi, håndbyggede højttalere og akustisk rådgivning. Book en demo i vores lytterum i Sydals.",
      original_url: "https://www.jarcon.dk/",
      hero_heading: "Musik med nerve",
      hero_subheading: "Kom forbi til et nyt lyt og en kop kaffe",
      hero_image: [
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/scandinavian-hifi-listening-room.png"
      ],
      content: "<p>Velkommen til JARCon ApS og vores dedikerede HiFi-univers, JARC Audio. Her handler det om den ægte musikoplevelse – lyden, nærværet og den kompromisløse glæde ved velkonstrueret udstyr.</p><p>Målet er at skabe en højtaler, som kan gengive al slags musik med nerve og nærvær, hvor lytteren glemmer at man lytter til HiFi, men føler sig omslugt at musikken.</p><p>Du er altid velkommen til at komme forbi vores lytterum på Toftehøj 21 i Sydals til en uforpligtende snak, et godt lyt og en friskbrygget kop kaffe.</p>",
      gallery_slug: "hifi-setup",
      cta_text: "Kom forbi til et nyt lyt",
      cta_link: "/kontakt",
      terms: { category: ["lytterum"] }
    },
    {
      id: "adf4d9e4-340f-4f38-97b1-b2faec59c91d",
      slug: "om-mig",
      title: "Om mig",
      seo_title: "Om Jens & JARCon | Passion for Teknik, Lyd & Håndværk",
      meta_description: "Mød Jens bag JARCon ApS og JARC Audio. Mange års passion for elektronik, præcisionshåndværk og kompromisløs lydgengivelse i Sydals.",
      original_url: "https://www.jarcon.dk/om-mig",
      hero_heading: "Om mig & JARCon",
      hero_subheading: "Passion for teknik, håndværk og kompromisløs lydgengivelse",
      hero_image: [
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-d78699cbcd994ac0866c1032fa7a7f83-mv2-d-4608-3072-s-4-2.jpg"
      ],
      content: "<p>HiFi og DIY HiFi har været en passion og hobby for mig i mange år.</p><p>Jeg har lavet pladespillere, kabler og tilbehør, men primært højtalerbyg, har min interesse. Det er blevet til mange spændende højtaler konstruktioner gennem årene.</p><p>JARCon ApS er grundlagt med et ønske om at skabe ærlige, gennemtænkte løsninger – både inden for rådgivning og i udviklingen af JARC Audio.</p>",
      gallery_slug: "hifi-setup",
      cta_text: "Tag en snak om dit projekt",
      cta_link: "/kontakt",
      terms: { category: ["hifi"] }
    },
    {
      id: "1a283b52-01bd-4a87-b1da-a233856ea332",
      slug: "ydelser",
      title: "Ydelser",
      seo_title: "Ydelser | Højtalerudvikling, CLIO Måling & Hypex Forstærkere - JARCon",
      meta_description: "Professionel højtalerudvikling på bestilling, præcisionsudmåling med CLIO pocket samt rådgivning og forhandling af Hypex Class D forstærkere og DSP hos JARCon ApS.",
      original_url: "https://www.jarcon.dk/ydelser",
      hero_heading: "Ydelser",
      hero_subheading: "Højtalerudvikling på bestilling, præcisionsudmåling og forhandling af high-end elektronik",
      hero_image: [
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-faa19ed76fd948908b3c8c846769fc3e-mv2-d-1800-1800-s-2.jpg"
      ],
      content: "<p>Da jeg gerne vil dele ud af min erfaring, tilbyder jeg at bygge højtalere på bestilling, men også hvis du har brug for inspiration til dit eget projekt.</p><p>Jeg tilbyder udmåling af dine højtalere med CLIO pocket målesystem: Frekvensgang, vandfaldskurve TS parametre m.m.</p><p>Forhandling af Hypex Class D forstærkere til fx aktive højtalere, samt DSP og forsyninger, alle i meget høj kvalitet.</p>",
      gallery_slug: "hifi-setup",
      cta_text: "Få en dialog om dit ønske",
      cta_link: "/kontakt",
      terms: { category: ["service"] }
    },
    {
      id: "bba8cd0c-27d0-4a92-a3d1-ef0482d63af4",
      slug: "kontakt",
      title: "Kontakt",
      seo_title: "Kontakt JARCon ApS | Aftal et Lyt i Lytterummet i Sydals",
      meta_description: "Kontakt Jens hos JARCon ApS for rådgivning om HiFi, specialbyggede højttalere eller et lyt i vores lytterum i Sydals. Tlf: +45 22 88 45 36.",
      original_url: "https://www.jarcon.dk/kontakt",
      hero_heading: "Kontakt",
      hero_subheading: "Aftal et besøg eller start en dialog",
      hero_image: [
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-75a790a4e93b4a67a6981ddeae1ed7f4-mv2.jpg"
      ],
      content: "<p>Du er altid velkommen til at kontakte mig for en uforpligtende snak om højtalere, udmåling, Hypex elektronik eller for at aftale tid til et lyt i mit setup.</p>",
      cta_text: "Send en besked",
      cta_link: "#kontaktformular",
      terms: { category: ["service"] }
    }
  ],
  galleries: [
    {
      id: "3e26b7a0-d159-4106-bd89-8996656724e7",
      slug: "hifi-setup",
      title: "Jens' HiFi Setup & Lytterum",
      description: "Mit setup med DIY højtalere, pladespiller og rørforstærker",
      images: [
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-10d0de04f8d84061b64ec76601f0ef3c-mv2.jpg",
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-75a790a4e93b4a67a6981ddeae1ed7f4-mv2.jpg",
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-d78699cbcd994ac0866c1032fa7a7f83-mv2-d-4608-3072-s-4-2.jpg"
      ],
      captions: "<p>Mit anlæg som det ser ud PT. Det får musikken til at \"gå under huden\" på lytteren, så man nærmest glemmer at det er et HiFi anlæg man lytter til</p><p>Lyttepositionen og pladereolen med meget forskelligt musik, samlet igennem mange år</p><p>Mono rørudgangstrin med 4 stk. KT150 rør som kan køre både Triode og Ultra-lineær drift. Håndviklede C-kerne trafoer</p>"
    }
  ],
  gallery_items: [
    {
      id: "151f3d99-aa63-4172-8c1d-0c712c336ff6",
      slug: "mit-anlaeg",
      gallery_slug: "hifi-setup",
      title: "Mit anlæg som det ser ud PT",
      caption: "Mit anlæg som det ser ud PT.\nDet får musikken til at \"gå under huden\" på lytteren, så man nærmest glemmer at det er et HiFi anlæg man lytter til",
      image: [
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-10d0de04f8d84061b64ec76601f0ef3c-mv2.jpg"
      ],
      order: 1
    },
    {
      id: "dfbd94ef-0900-4d6d-a079-0ea1c41f7cba",
      slug: "lyttepositionen",
      gallery_slug: "hifi-setup",
      title: "Lyttepositionen og pladereolen",
      caption: "Lyttepositionen og pladereolen med meget forskelligt musik, samlet igennem mange år",
      image: [
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-75a790a4e93b4a67a6981ddeae1ed7f4-mv2.jpg"
      ],
      order: 2
    },
    {
      id: "908bb5c0-b55f-48f6-8bf1-79b7c9fe0021",
      slug: "mono-roerudgangstrin",
      gallery_slug: "hifi-setup",
      title: "Mono rørudgangstrin",
      caption: "Mono rørudgangstrin med 4 stk. KT150 rør som kan køre både Triode og Ultra-lineær drift. Håndviklede C-kerne trafoer",
      image: [
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-d78699cbcd994ac0866c1032fa7a7f83-mv2-d-4608-3072-s-4-2.jpg"
      ],
      order: 3
    }
  ],
  hifi_items: [
    {
      id: "943a66fe-60a2-48ab-9323-13f21514b293",
      slug: "hoejtaler-udvikling",
      title: "Højtaler udvikling",
      summary: "Da jeg gerne vil dele ud af min erfaring, tilbyder jeg at bygge højtalere på bestilling, men også hvis du har brug for inspiration til dit eget projekt.",
      body: "<p>Da jeg gerne vil dele ud af min erfaring, tilbyder jeg at bygge højtalere på bestilling, men også hvis du har brug for inspiration til dit eget projekt.</p><p>Ring eller skriv for at få en dialog om ønsker og muligheder for at skabe din helt egen højtaler</p>",
      image: [
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-10d0de04f8d84061b64ec76601f0ef3c-mv2.jpg"
      ],
      badge: "Håndbygget på bestilling",
      order: 1,
      terms: { category: ["service"] }
    },
    {
      id: "284cdd15-dd61-4c2c-80b7-d9dc7e06a555",
      slug: "hoejtaler-udmaaling",
      title: "Højtaler udmåling",
      summary: "Jeg tilbyder udmåling af dine højtalere med CLIO pocket målesystem: Frekvensgang, vandfaldskurve TS parametre m.m.",
      body: "<p>Jeg tilbyder udmåling af dine højtalere med CLIO pocket målesystem:</p><p>Frekvensgang, vandfaldskurve TS parametre m.m.</p>",
      image: [
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-faa19ed76fd948908b3c8c846769fc3e-mv2-d-1800-1800-s-2.jpg"
      ],
      badge: "CLIO Pocket Målesystem",
      order: 2,
      terms: { category: ["service"] }
    },
    {
      id: "aeb85539-5247-4136-a494-7378927b1715",
      slug: "forhandling-hypex-elektronik",
      title: "Forhandling af Hypex Elektronik",
      summary: "Forhandling af Hypex Class D forstærkere til fx aktive højtalere, samt DSP og forsyninger, alle i meget høj kvalitet",
      body: "<p>Forhandling af Hypex Class D forstærkere til fx aktive højtalere, samt DSP og forsyninger, alle i meget høj kvalitet</p>",
      image: [
        "https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-b1d6f3a7c07e4c09a8e1566b4ae5990e-mv2.png"
      ],
      badge: "Autoriseret Forhandler",
      order: 3,
      terms: { category: ["forhandling"] }
    }
  ],
  navigation_items: [
    {
      id: "b368c3b3-cbd9-4aff-ada2-5b6ab81b2a3d",
      slug: "nav-hjem",
      label: "Hjem",
      url: "/",
      order: 1,
      is_highlighted: false
    },
    {
      id: "0d496de8-24fa-438a-ba2d-d7378db7bd63",
      slug: "nav-hifi",
      label: "HiFi",
      url: "/hifi",
      order: 2,
      is_highlighted: false
    },
    {
      id: "04a3e98b-2b9c-440b-93b5-ee5abbc572f7",
      slug: "nav-om-mig",
      label: "Om mig",
      url: "/om-mig",
      order: 3,
      is_highlighted: false
    },
    {
      id: "926fb2fb-e6ad-480b-bad0-44e9e58fe39a",
      slug: "nav-ydelser",
      label: "Ydelser",
      url: "/ydelser",
      order: 4,
      is_highlighted: false
    },
    {
      id: "53b4947b-d4dd-4cd0-910d-8eec12ee73f7",
      slug: "nav-kontakt",
      label: "Kontakt",
      url: "/kontakt",
      order: 5,
      is_highlighted: true
    }
  ]
}

/**
 * Normalizes an entry's slug whether stored as string or localized object
 */
export function getEntrySlug(entry) {
  if (!entry) return ''
  if (typeof entry.slug === 'string') return entry.slug
  if (entry.slug && typeof entry.slug === 'object') {
    return entry.slug._ || entry.slug.da || Object.values(entry.slug)[0] || ''
  }
  return ''
}

/**
 * Fetch a CMS collection with fallback
 */
export async function getCmsCollection(collectionName) {
  try {
    const res = await fetch(`${CMS_BASE_URL}/public/content/${collectionName}`, {
      headers: { Accept: 'application/json' }
    })
    if (res.ok) {
      const data = await res.json()
      if (Array.isArray(data) && data.length > 0) {
        return data
      }
    }
  } catch {
    // network fallback
  }
  return FALLBACK_DATA[collectionName] || []
}

/**
 * Get a specific page by slug
 */
export async function getCmsPage(slug) {
  const pages = await getCmsCollection('pages')
  const found = pages.find((p) => getEntrySlug(p) === slug || p.slug === slug)
  if (found) return found
  return FALLBACK_DATA.pages.find((p) => p.slug === slug) || null
}

/**
 * Get a gallery by its slug, including its individual gallery_items
 */
export async function getCmsGallery(gallerySlug) {
  const [galleries, items] = await Promise.all([
    getCmsCollection('galleries'),
    getCmsCollection('gallery_items')
  ])

  const gallery = galleries.find((g) => getEntrySlug(g) === gallerySlug || g.slug === gallerySlug) ||
    FALLBACK_DATA.galleries.find((g) => g.slug === gallerySlug)

  const galleryItems = items
    .filter((it) => it.gallery_slug === gallerySlug)
    .sort((a, b) => (a.order || 0) - (b.order || 0))

  return {
    gallery: gallery || null,
    items: galleryItems.length > 0 ? galleryItems : (FALLBACK_DATA.gallery_items.filter(i => i.gallery_slug === gallerySlug))
  }
}
